import { Field, TextInput, TextArea, SectionCard } from "./_shared";

export default function EditBmi({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const setCat = (catKey, field, v) => {
    onChange({ ...value, [catKey]: { ...(value[catKey] || {}), [field]: v } });
  };

  const CATEGORIES = [
    { key: "categoryMagro", title: "Magro (IMC < 18,5)" },
    { key: "categoryNormal", title: "Normal (IMC 18,5 – 24,9)" },
    { key: "categorySobrepeso", title: "Sobrepeso (IMC 25 – 29,9)" },
    { key: "categoryObesidade", title: "Obesidade (IMC ≥ 30)" },
  ];

  return (
    <div className="space-y-6">
      <SectionCard title="Calculadora de IMC">
        <div className="space-y-5">
          <Field label="Overline"><TextInput value={value.overline} onChange={(v) => set("overline", v)} testId="bmi-overline-input" /></Field>
          <Field label="Título"><TextInput value={value.title} onChange={(v) => set("title", v)} testId="bmi-title-input" /></Field>
          <Field label="Subtítulo"><TextArea value={value.subtitle} onChange={(v) => set("subtitle", v)} rows={2} testId="bmi-subtitle-input" /></Field>
          <Field label="Texto do botão calcular"><TextInput value={value.ctaLabel} onChange={(v) => set("ctaLabel", v)} testId="bmi-cta-label-input" /></Field>
          <Field label="Texto do botão após resultado"><TextInput value={value.resultCtaLabel} onChange={(v) => set("resultCtaLabel", v)} testId="bmi-result-cta-input" /></Field>
          <Field label="Aviso/disclaimer"><TextArea value={value.disclaimer} onChange={(v) => set("disclaimer", v)} rows={2} testId="bmi-disclaimer-input" /></Field>
          <div className="grid sm:grid-cols-2 gap-3">
            <Field label="Rótulo Mulher"><TextInput value={value.sexLabelFemale} onChange={(v) => set("sexLabelFemale", v)} testId="bmi-female-input" /></Field>
            <Field label="Rótulo Homem"><TextInput value={value.sexLabelMale} onChange={(v) => set("sexLabelMale", v)} testId="bmi-male-input" /></Field>
          </div>
          <div className="grid sm:grid-cols-3 gap-3">
            <Field label="Rótulo Idade"><TextInput value={value.ageLabel} onChange={(v) => set("ageLabel", v)} testId="bmi-age-label-input" /></Field>
            <Field label="Rótulo Altura"><TextInput value={value.heightLabel} onChange={(v) => set("heightLabel", v)} testId="bmi-height-label-input" /></Field>
            <Field label="Rótulo Peso"><TextInput value={value.weightLabel} onChange={(v) => set("weightLabel", v)} testId="bmi-weight-label-input" /></Field>
          </div>
        </div>
      </SectionCard>

      <SectionCard title="Mensagens Por Faixa de IMC">
        <div className="space-y-5">
          {CATEGORIES.map((cat) => (
            <div key={cat.key} className="border border-border p-4 space-y-3">
              <p className="text-xs tracking-[0.2em] uppercase text-gold">{cat.title}</p>
              <Field label="Rótulo">
                <TextInput
                  value={(value[cat.key] || {}).label}
                  onChange={(v) => setCat(cat.key, "label", v)}
                  testId={`bmi-${cat.key}-label`}
                />
              </Field>
              <Field label="Mensagem ao usuário">
                <TextArea
                  value={(value[cat.key] || {}).message}
                  onChange={(v) => setCat(cat.key, "message", v)}
                  rows={3}
                  testId={`bmi-${cat.key}-message`}
                />
              </Field>
            </div>
          ))}
        </div>
      </SectionCard>
    </div>
  );
}
